import * as React from 'react';
import * as styles from './Counter.css';
import { InlineText3 } from '@cian/ui-kit';

import { IconMediaPhoto16 } from '@cian/ui-kit-design-tokens/icons';

interface ICounterProps {
  currentSlide: number;
  totalSlides: number;
}

export const Counter: React.FC<ICounterProps> = props => {
  const { currentSlide, totalSlides } = props;

  return (
    <div className={styles['container']}>
      <IconMediaPhoto16 color={'icon-inverted-default'} />
      <div className={styles['counter']}>
        <InlineText3 color={'text-inverted-default'}>
          {currentSlide}/{totalSlides}
        </InlineText3>
      </div>
    </div>
  );
};

Counter.displayName = 'Counter';
